import { Button } from "@/components/UI/Buttons/Button";
import { useEffect, useState } from "react";
import { adminControlClass, adminLabelClass } from "../../../Shared/adminUi";

interface SimplePromptFormProps<P> {
  onSubmit: (content: string) => void;
  onUpdate: (prompt: P) => void;
  editingPrompt?: P;
  onCancelEdit: () => void;
  title?: string;
}

function SimplePromptForm<
  P extends { id: number; name: string; content: string },
>({
  onSubmit,
  onUpdate,
  editingPrompt,
  onCancelEdit,
  title,
}: SimplePromptFormProps<P>) {
  const [content, setContent] = useState<string>("");

  useEffect(() => {
    if (editingPrompt) {
      setContent(editingPrompt.content);
    } else {
      setContent("");
    }
  }, [editingPrompt]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (!content.trim()) return;

    if (editingPrompt) {
      onUpdate({
        ...editingPrompt,
        content: content.trim(),
      });
    } else {
      onSubmit(content.trim());
      setContent("");
    }
  };

  return (
    <form className="flex flex-col" onSubmit={handleSubmit}>
      <h4 className="text-ink mb-4 text-center font-semibold">
        {editingPrompt ? "Redaguoti prompt" : title || "Pridėti naują prompt"}
      </h4>
      <div className="mb-4">
        <label className={adminLabelClass}>Turinys</label>
        <textarea
          className={adminControlClass}
          rows={6}
          value={content}
          onChange={(event) => setContent(event.target.value)}
          required
        />
      </div>

      <Button type="submit" className="mt-4" size="sm">
        {editingPrompt ? "Išsaugoti pakeitimus" : "Išsaugoti"}
      </Button>

      {editingPrompt && (
        <Button
          variant="secondary"
          type="button"
          className="mt-2"
          size="sm"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onCancelEdit();
          }}
        >
          Atšaukti redagavimą
        </Button>
      )}
    </form>
  );
}

export default SimplePromptForm;
